// extracted by mini-css-extract-plugin
export default {"rootDiv":"style_rootDiv__1pfEj"};